import React from "react";

function About() {
  return (
    <div className="container mt-5 pt-4">
      <h2 className="fw-bold">About Barbara PH Properties</h2>
      <p className="lead text-muted">
        At Barbara PH Properties, our mission is to provide exceptional service
        and trusted expertise to help clients achieve their real estate goals.
      </p>

      <p>
        With years of experience in the industry, our dedicated team has built a
        reputation for excellence, integrity, and personalized guidance. We
        believe that finding or selling a home should be a rewarding journey,
        and we are committed to making the process seamless and transparent.
      </p>

      <p>
        We stay ahead of the curve by embracing the latest trends and
        technologies in the real estate market. From curated listings to
        innovative marketing strategies, we use our knowledge to empower clients
        with confidence at every step of the buying and selling process.
      </p>

      <p className="mb-0">
        Whether you’re searching for your dream home, investing in property, or
        selling with ease, Barbara PH Properties is your trusted partner in
        turning real estate aspirations into reality.
      </p>
    </div>
  );
}

export default About;
